import "../styles/Footer.css";

function MyFooter() {
  return (
    <footer className="App-footer">
      <h3> © Copyright Boughton-Shields Creations 2025 </h3>
    </footer>
  );
}

export default MyFooter;
